import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class AlloyService {

  private alloySource = new BehaviorSubject({})
  currentAlloy = this.alloySource.asObservable();
  

  noAuthHeader = { headers: new HttpHeaders({ 'NoAuth': 'True' }) };
  constructor(private http: HttpClient) { }

  saveAlloy(alloyData){
   //console.log('saving data', alloyData);
    return this.http.post<any>(environment.apiBaseUrl+'/customer/post-alloy-data', alloyData)
  }

  getAlloy(){
    return this.http.get(environment.apiBaseUrl+'/customer/get-alloy-data')
  }

  getStandardAlloys(){
    return this.http.get(environment.apiBaseUrl+'/customer/get-all-standard-alloy')
  }

  getStandardAlloy(id){
    return this.http.get(environment.apiBaseUrl+'/customer/get-standard-alloy', id)
  }

  changeAlloy(alloy){
    this.alloySource.next(alloy)
  }

  editAlloy(newAlloyObject){
    return this.http.post<any>(environment.apiBaseUrl+'/customer/update-alloy-data', newAlloyObject)
  }

  deleteAlloy(alloyToBeDeleted){
    return this.http.post<any>(environment.apiBaseUrl+'/customer/delete-alloy-data', alloyToBeDeleted)
  }

}
